import { useEffect, useState } from "react";
import { supabase } from "./lib/supabase";

type Rule = { method_key: string; enabled: boolean; proof_requirement: "required" | "optional" };

const labels: Record<string, string> = {
  trade_in: "Retoma",
  cash: "Numerário",
  bank_transfer: "Transferência bancária",
  financing: "Financiamento",
  card: "Cartão",
  cheque: "Cheque",
  mbway: "MB WAY",
  other: "Outro",
};

export function StandPaymentSettings({ organizationId, canManage }: { organizationId: string; canManage: boolean }) {
  const [rules, setRules] = useState<Rule[]>([]);
  const [notice, setNotice] = useState<string | null>(null);
  const [updating, setUpdating] = useState<string | null>(null);

  const load = async () => {
    const { data, error } = await supabase
      .from("organization_payment_method_settings")
      .select("method_key,enabled,proof_requirement")
      .eq("organization_id", organizationId)
      .order("method_key");
    if (error) setNotice(error.message);
    setRules((data ?? []) as Rule[]);
  };

  useEffect(() => void load(), [organizationId]);
  useEffect(() => {
    if (!notice) return;
    const timer = setTimeout(() => setNotice(null), 10000);
    return () => clearTimeout(timer);
  }, [notice]);

  const update = async (rule: Rule, changes: Partial<Rule>) => {
    setUpdating(rule.method_key);
    setNotice(`A guardar a regra de ${labels[rule.method_key]}…`);
    const next = { ...rule, ...changes };
    const { error } = await supabase
      .from("organization_payment_method_settings")
      .update({ enabled: next.enabled, proof_requirement: next.proof_requirement, updated_at: new Date().toISOString() })
      .eq("organization_id", organizationId)
      .eq("method_key", rule.method_key);
    setNotice(error ? error.message : "Regra atualizada.");
    if (!error) setRules((current) => current.map((item) => (item.method_key === rule.method_key ? next : item)));
    setUpdating(null);
  };

  return (
    <div className="payment-settings">
      <div className="settings-foundation-status">
        <strong>Meios de pagamento e comprovativos</strong>
        <p>Cada parcela guarda uma cópia da regra aplicada. Alterações futuras não modificam vendas anteriores.</p>
      </div>
      {notice && <button className="stock-notice" role="status" aria-live="polite" onClick={() => setNotice(null)}>{notice} ×</button>}
      <div className="payment-settings-list">
        {rules.map((rule) => (
          <article key={rule.method_key}>
            <div><strong>{labels[rule.method_key]}</strong><small>{rule.proof_requirement === "required" ? "Exige comprovativo" : "Comprovativo facultativo"}</small></div>
            <label className="simple-checkbox"><input type="checkbox" checked={rule.enabled} disabled={!canManage || updating !== null} onChange={(event) => void update(rule, { enabled: event.target.checked })}/><span>{updating === rule.method_key ? "A guardar…" : "Disponível"}</span></label>
            <label><span>Comprovativo</span><select value={rule.proof_requirement} disabled={!canManage || !rule.enabled || updating !== null} onChange={(event) => void update(rule, { proof_requirement: event.target.value as Rule["proof_requirement"] })}><option value="optional">Facultativo</option><option value="required">Obrigatório</option></select></label>
          </article>
        ))}
      </div>
    </div>
  );
}
